@if (breadcrumbItems | translateMenuItems | async; as breadcrumbItems) {
  <p-breadcrumb
    data-id="breadcrumb"
    [model]="breadcrumbItems"
    [style]="{ border: 'none' }"
    (onItemClick)="onItemClick($event)"
  >
    <ng-template #separator>/</ng-template>
    <ng-template #item let-item
      ><div
        class="bd-menuitem-text"
        data-id="breadrcrumb-item"
        (click)="onItemClick(item)"
        (keydown)="onItemClick(item)"
      >
        <bd-text-overflow-tooltip
          class="min-w-0 max-w-full"
          [text]="item.label"
          [fontSize]="fontSize"
          tooltipPosition="bottom"
        ></bd-text-overflow-tooltip></div
    ></ng-template>
  </p-breadcrumb>
}
